<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Tags</div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-text>
          <Dialog  :tag="tag" />
        </v-card-text> 

        <v-divider />

        <v-card-actions>
        <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">Sair</v-btn>
        </v-card-actions> 
      </v-card>  
    </v-dialog>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataTags"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/tags/criar"
              target="_blank"
              @click="handleGoToNewTag"
            >
              Criar TAG
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="search"
              clearable
              hide-details
              prepend-inner-icon="mdi-magnify"
              label="Busca"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                    @click="openDialog(item)"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
              <span>Uso</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/tags/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="deletar(item)"
                  icon
                  small
                  dark
                  color="darkRed"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Tags: {{ qtdTags }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import ListPagination from "@/componentes/ListPagination";
import { pagesHomeMixins } from "@/mixins/pagesHomeMixins";

import tagHttpService from "../_services/tagHttpService";
import tagsStore from "../_store";
import Dialog from '../_components/Dialog.vue'

export default {
  components: { ListPagination, Dialog },

  mixins: [pagesHomeMixins],

  data: () => ({
    // sortBy: "description",
    headers: [
      {
        text: "Descrição",
        value: "description",
        align: "left",
      },
      {
        text: "Ações",
        value: "botoes",
        align: "center",
        sortable: false,
      },
    ],
    dataTags: [],
    tag: {},
    dialog: false,
  }),

  computed: {
    ...mapGetters("tagHomeModulePABXStore", ["getTags"]),

    numberOfPages() {
      return Math.ceil(this.dataTags.length / this.itemsPerPage);
    },
    qtdTags() {
      return this.dataTags.length;
    },
  },

  async created() {
    registerVuexModule(this.$store, "tagHomeModulePABXStore", tagsStore);

    await this.listarTags();
    this.dataTags = [...this.getTags];

    this.showSkeleton = false;
  },

  methods: {
    ...mapActions("tagHomeModulePABXStore", ["listarTags", 'listarTagUse']),

    handleGoToNewTag(event) {
      event.preventDefault();
      if (event.metaKey || event.ctrlKey) {
        const goToNewTag = this.$router.resolve({ name: "Tags/criar" });
        window.open(goToNewTag.href, "_blank");
      } else {
        this.$router.push({ name: "Tags/criar" });
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(
          `tags/atualizar/${item.item._id}`
        );
        window.open(updatePath.href, "_blank");
      } else {
        this.$router.push(`tags/atualizar/${item.item._id}`);
      }
    },

    atualizarButton(item, event) {
      event.preventDefault();
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`tags/atualizar/${item._id}`);
        window.open(updatePath.href, "_blank");
      } else {
        this.$router.push(`tags/atualizar/${item._id}`);
      }
    },

    async deletar(item) {
      let resultado = window.confirm(
        `Deseja remover a TAG "${item.description}"?`
      );
      if (resultado) {
        try {
          await tagHttpService.deleteTag(item._id);
          this.dataTags = this.dataTags.filter((x) => x._id !== item._id);
        } catch (error) {
          alert(error.response.data);
        }
      }
    },
    async openDialog(tag) {
      await this.listarTagUse(tag._id)
      this.tag = tag
      this.dialog = true
    }
  },
};
</script>
